(function(){
     'use strict';

     angular
        .module('appback')
        .factory('ResultadosService', ResultadosService);

    ResultadosService.$inject = ['$http', '$q'];

    function ResultadosService($http, $q){

        var service= {
           getAnaliticasByIdPeticion:getAnaliticasByIdPeticion,
           getSubanaliticasByAnalitica:getSubanaliticasByAnalitica,
           getMediosCondiciones:getMediosCondiciones,
           getATB:getATB,
           cambiarResultado:cambiarResultado,
           validador:validador,
           getDiagnosticoPlantilla:getDiagnosticoPlantilla,
           getDiagnosticoBiopPlantilla:getDiagnosticoBiopPlantilla,
           getDiagnosticoMielPlantilla:getDiagnosticoMielPlantilla,
           guardarResultados:guardarResultados,
           cambiarMostrar:cambiarMostrar,
           validarInforme :validarInforme,
           getComentarios:getComentarios,
           getOperacionMat:getOperacionMat,
           deslogear:deslogear,
           getIntAntibioticoMicro:getIntAntibioticoMicro,
           getResMaquinaAnalitica:getResMaquinaAnalitica,
           getProteinaTotal:getProteinaTotal,
           guardarExtern:guardarExtern,
           getPlantillaMargen:getPlantillaMargen,
           getAccionesByPet:getAccionesByPet,
           getProteinaOrina:getProteinaOrina,
           getAnaliticasSimilares:getAnaliticasSimilares,
           cambiarAnalitica:cambiarAnalitica,
           guardarAccion:guardarAccion,
           getTemplateAcciones:getTemplateAcciones,
           guardarMultpat:guardarMultpat,
           cambiarEstadoMuestra:cambiarEstadoMuestra,
           repetirAnalitica:repetirAnalitica,
           visitaResultado:visitaResultado,
           getBioquimica:getBioquimica,
           cambiarLab:cambiarLab,
           marcarFav:marcarFav,
           getTablanotas:getTablanotas,
           saveTablanotas:saveTablanotas,
           getCtAnalitica:getCtAnalitica,
           base64toJPG:base64toJPG

        };

        return service;

        function base64toJPG(filename,base64,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                },
            }
            var data = $.param({ 
                filename:filename,
                base64:base64
            });
            $http.post('/backend/resultadopeticion/base64toimg',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getCtAnalitica(getscope,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/resultadopeticion/getctanalitica', { params : { analitica_id : getscope.item.analitica_id, lote:getscope.item.resultado.extra.resultado.lote }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getTablanotas(langcode,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/resultadopeticion/gettablanotas', { params : { langcode:langcode } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

         function saveTablanotas(lang_trans,tablanotasvalores,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                },
            }
            var data = $.param({ 
                lang_trans:lang_trans,
                tablanotasvalores:JSON.stringify(tablanotasvalores) 
            });
            $http.post('/backend/resultadopeticion/savetablanotas',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        


        function cambiarEstadoMuestra(item,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                },
            }
            var data = $.param({ 
                id:item.id,
                estadomuestra:item.estadomuestra_id
            });
            $http.post('/backend/resultadopeticion/cambiarestado',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function marcarFav(item,favs,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                },
            }
            var data = $.param({ 
                resultado_id:item.resultado.id,
                peticion_id:item.peticion.id,
                analitica_id:item.analitica_id,
                favs:JSON.stringify(favs) 
            });
            $http.post('/backend/resultadopeticion/marcarfav',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function cambiarLab(item,laboratorio_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                },
            }
            var data = $.param({ 
                peticion_id:item.peticion_id,
                laboratorio_id:laboratorio_id,
                analitica_id:item.analitica_id
            });
            $http.post('/backend/resultadopeticion/cambiarlab',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function visitaResultado(id,force,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                },
                ignoreLoadingBar: true
            }
            var data = $.param({ 
                id:id,
                force:force
            });
            $http.post('/backend/resultadopeticion/visitaresultado',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function repetirAnalitica(analitica_id,resultado_id,comentario,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({ 
                analitica_id:analitica_id,
                resultado_id:resultado_id,
                comentario:comentario
            });
            $http.post('/backend/resultadopeticion/repetiranalitica',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
 		function getAnaliticasByIdPeticion(id,analitica_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/resultadopeticion/getanaliticasresultados', { params : { analitica_id:analitica_id, peticion : id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getTemplateAcciones(id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/resultadopeticion/gettemplateacciones', { params : { subtipo_id:id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function cambiarAnalitica(scopeRes,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/resultadopeticion/cambiaranalitica', { params : { prueba_final:scopeRes.prueba_final, peticion : scopeRes.item.peticion_id, analitica_id:scopeRes.item.analitica_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getAnaliticasSimilares(item,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/resultadopeticion/getanaliticassimilares', {  params : {peticion : item.peticion_id, analitica_id:item.analitica_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        

        function getAccionesByPet(id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/resultadopeticion/getaccionesbypet', { ignoreLoadingBar: true, params : {peticion : id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

         function getPlantillaMargen(margen,centro_lang_code,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/resultadopeticion/getmargenplantilla', { params : { margen:margen,centro_lang_code:centro_lang_code } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getProteinaTotal(id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/resultadopeticion/getproteinatotal', { ignoreLoadingBar: true, params : { peticion : id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getBioquimica(id,analitica_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/resultadopeticion/getbioquimica', { ignoreLoadingBar: true, params : { peticion : id, analitica_id:analitica_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
         function getProteinaOrina(id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/resultadopeticion/getproteinaorina', { ignoreLoadingBar: true, params : { peticion : id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getResMaquinaAnalitica(peticion_id,analitica_id,categoria_id,lims_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }

            }

            $http.get('/backend/resultadopeticion/getresmaquina', { ignoreLoadingBar: true, params : { lims_id,lims_id,categoria_id:categoria_id,analitica_id:analitica_id, peticion_id : peticion_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        

        function getIntAntibioticoMicro(atb,micro,tecnica,resultado,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                },
                ignoreLoadingBar: true
            }

            $http.get('/backend/resultadopeticion/getinterpretacionmicro', { ignoreLoadingBar: true, params : { resultado:resultado,atb:atb,micro:micro, tecnica : tecnica } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function deslogear(callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/resultadopeticion/deslogear', { params : {  } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getOperacionMat(id,analitica_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/resultadopeticion/getoperacionmat', { params : { analitica_id:analitica_id, peticion : id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function validador(login,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/resultadopeticion/validador', { params : { log:login } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getComentarios(text,categoria,lang_id_p,popup,removeTags,page,callback)
        {
            var canceller = $q.defer();
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
 
            var cancel = function(reason){
                console.log("Cancelando..");
                canceller.resolve(reason);
            };
 
            var promise = $http.get('/backend/resultadopeticion/getcomentarios', { ignoreLoadingBar:true,  timeout: canceller.promise, params : { popup:popup, text : text, categoria : categoria, lang_id:lang_id_p,removeTags:removeTags,page:page } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
            return {
                promise: promise,
                cancel: cancel
            };
        }

        function guardarExtern(result,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            $http.get('/backend/resultadopeticion/guardarextern', { params : { result:JSON.stringify(result) } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function cambiarResultado(peticion_id,comprobar,item,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({ 
                comprobar:comprobar,
                peticion_id:peticion_id,
                item:JSON.stringify(item) 
            });
            $http.post('/backend/resultadopeticion/cambiarresultado',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function guardarMultpat(items,validador,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({ 
                validador:validador,
                items:JSON.stringify(items) 
            });
            $http.post('/backend/resultadopeticion/asignarvalidador',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        
        function guardarAccion(scopeVm,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({ 
                accion:JSON.stringify(scopeVm.nodeaccion) 
            });
            $http.post('/backend/resultadopeticion/guardaraccion',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function validarInforme(id,item,validar,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param(
                { 
                    peticion_id:id,
                    validar:validar,
                    item:JSON.stringify(item)
                }
               );
            $http.post('/backend/resultadopeticion/validarinforme', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }

        function cambiarMostrar(peticion_id,mostrar,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            //console.log(item);
            //console.log(item.toString());
            //console.log(JSON.stringify(item));
            $http.get('/backend/resultadopeticion/cambiarmostrar', { params : { mostrar:mostrar,peticion_id:peticion_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function guardarResultados(analitica_id,peticion_id,resSimplificado,comentarios,callback)
        {

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param(
                { 
                    analitica_id:analitica_id,
                    peticion_id:peticion_id,
                    item:JSON.stringify(resSimplificado),
                    comentarios:JSON.stringify(comentarios) }
               );
            $http.post('/backend/resultadopeticion/guardarresultados', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }

        function getDiagnosticoPlantilla(tejido,diagnostico,centro_lang_code,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/resultadopeticion/getdiagnosticoplantilla', { params : { tejido:tejido,diagnostico:diagnostico,centro_lang_code:centro_lang_code } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

         function getDiagnosticoMielPlantilla(tejido,diagnostico,idioma_code,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/resultadopeticion/getdiagnosticoplantillamiel', { params : { tejido:tejido,diagnostico:diagnostico,idioma_code:idioma_code } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

         function getDiagnosticoBiopPlantilla(diagnostico,idioma_code,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/resultadopeticion/getdiagnosticoplantillabiop', { params : { diagnostico:diagnostico,idioma_code:idioma_code } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getATB(analitica_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/resultadopeticion/getantibioticos', { params : { analitica_id : analitica_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        
        function getMediosCondiciones(analitica_id,pais_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/resultadopeticion/getmedioscondiciones', { params : { analitica_id : analitica_id, pais_id:pais_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getSubanaliticasByAnalitica(analitica_id,especie_id,idioma_code,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                },
                ignoreLoadingBar: true
                
            }

            $http.get('/backend/resultadopeticion/getsubanaliticasbyanalitica', { ignoreLoadingBar: true,params : { analitica_id : analitica_id,especie_id:especie_id,idioma_code:idioma_code } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

      
    }
})();